// src/redux/reducers/role-management/permission/permissionReducer.js
import {
  CREATE_PERMISSION_REQUEST,
  CREATE_PERMISSION_SUCCESS,
  CREATE_PERMISSION_FAILURE,
  FETCH_PERMISSIONS_REQUEST,
  FETCH_PERMISSIONS_SUCCESS,
  FETCH_PERMISSIONS_FAILURE,
} from "../../../actions/role-management/permission/permissionActions";

const initialState = {
  loading: false,
  permissions: [],
  error: null,
};

const permissionReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PERMISSION_REQUEST:
    case FETCH_PERMISSIONS_REQUEST:
      return { ...state, loading: true, error: null };

    case CREATE_PERMISSION_SUCCESS:
      return { ...state, loading: false, error: null };

    case FETCH_PERMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        permissions: action.payload,
        error: null,
      };

    case CREATE_PERMISSION_FAILURE:
    case FETCH_PERMISSIONS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default permissionReducer;
